<template>
  <div class="otherJobItem">
    <div class="jobName clearfix">
      <div class="fl name textOverflow cursor" @click="toPosition">
        {{ sameItem.name | textFormat }}
      </div>
      <div class="fr salary">
        <span v-if="sameItem.salary_lowest!=0"
          >{{ sameItem.salary_lowest | textFormat }}K —
         {{ sameItem.salary_highest==21?`20K以上`:`${sameItem.salary_highest}K` }}</span
        >
        <span v-else style="font-size: 12px">薪资面议</span>
      </div>
    </div>
    <div class="describe">
      <span
        >{{ sameItem.city_name_zh || sameItem.city_name_en || "-" }}
        |
      </span>
      <span>{{ sameItem.experience | experienceFormat(LOCALE) }} </span>
      <span>| {{ sameItem.level_require | levelRequireFormat("zh") }}</span>
    </div>
    <div class="company clearfix">
      <div class="fl">
        <el-image
          :src="sameItem.logo ? sameItem.logo : defaultLogo"
          class="img"
        ></el-image>
      </div>
      <div class="fl content">
        <div
          class="name_c textOverflow"
          :title="
            sameItem.company_name_en
              | priorFormat(sameItem.company_name_zh, 'zh')
          "
        >
          {{
            sameItem.company_name_en
              | priorFormat(sameItem.company_name_zh, "zh")
              | textFormat
          }}
        </div>
        <div class="type textOverflow">
          {{ sameItem.industry | industryFormat("zh") | textFormat }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    sameItem: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    toPosition() {
      this.$router.push({
        path: "/positionDetail",
        query: {
          parameter: this._encode({
            id: parseInt(this.sameItem.position_id),
          }),
        },
      });
    },
    toCompany() {
      this.$router.push({
        path: "/companyList/booth",
        query: {
          parameter: this._encode({
            company_id:this.sameItem.company_id 
          }),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.otherJobItem {
  font-size: 14px;
  .jobName {
    font-size: 16px;
    margin-bottom: 6px;
  }
  .name {
    max-width: 300px;
  }
  
  .salary {
    color: #ff2b0d;
  }
  .describe {
    color: #999999;
    padding-bottom: 16px;
    border-bottom: 1px solid #e9e9e9;
  }
  .company {
    display: flex;
    .img {
      width: 70px;
      height: 70px;
      margin: 16px 16px 16px 0;
    }
    .content {
      width: 300px;
      margin: 26px 0;
      font-size: 16px;
      .name_c{
        width: 270px;
      }
    }
    .type {
      color: #999999;
      font-size: 14px;
      margin-top: 6px;
    }
  }
}
</style>